(function () {
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Onda al pulsar botones y tarjetas
  var SEL = '.button, .rg-btn, .whatsapp-order__button, .whatsapp-cart__button, .rg-escudo, .rg-cat';
  document.addEventListener('pointerdown', function (e) {
    if (reducido) return;
    var el = e.target.closest(SEL);
    if (!el || el.disabled) return;
    var r = el.getBoundingClientRect();
    var size = Math.max(r.width, r.height) * 2;
    var onda = document.createElement('span');
    onda.className = 'rg-onda';
    onda.style.width = onda.style.height = size + 'px';
    onda.style.left = (e.clientX - r.left - size / 2) + 'px';
    onda.style.top = (e.clientY - r.top - size / 2) + 'px';
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.style.overflow = 'hidden';
    el.appendChild(onda);
    setTimeout(function () { onda.remove(); }, 650);
  });

})();
